// This was added by toggleGlobals.js script (!)
export const ajaxDebug = false;
export const wsDebug = false;
export const MOCK = false;
export const APIurl = 'https://bi-tu-bi.ru/api';
export const WS_API_URL = 'wss://bi-tu-bi.ru/apiws/ws';
